import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import tableSortedDescendingIcon from '../img/tableSortedDescending.svg'

const SortedColumnIcon = ({ className, column }) => {
  if (column.disableSortBy) return null

  return (
    <img
      alt={`Sorted by ${column.isSortedDesc ? 'newest' : 'oldest'} order first.`}
      className={`${className} ${column.isSortedDesc ? '' : 'ascending'}`}
      src={tableSortedDescendingIcon}
    />
  )
}

SortedColumnIcon.defaultProps = {
  className: '',
}

SortedColumnIcon.propTypes = {
  className: PropTypes.string,
  column: PropTypes.shape({
    disableSortBy: PropTypes.bool,
    isSortedDesc: PropTypes.bool,
  }).isRequired,
}

const StyledSortedColumnIcon = styled(SortedColumnIcon)({
  marginBottom: '-2px',
  marginLeft: '8px',
  '&.ascending': {
    marginBottom: '0',
    transform: 'rotate(180deg)',
  },
})

export default StyledSortedColumnIcon
